module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align pt-5",
    attrs: {
      "id": "reorder"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "indeterminate": ""
    }
  }), _c('br'), _vm._v("\n  Creating Order...\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c660604","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/reorder.vue
// module id = 787
// module chunks = 1